<template>
    <div class="app-loading" v-if="needSpinnerShow">
        <q-inner-loading :showing="needSpinnerShow" class="app-loading__inner" color="primary" label="Подготовка к работе"/>
    </div>
    <router-view v-if="loaded"/>
</template>
<script>
import { defineComponent } from 'vue';
import moment from 'moment';
import 'src/lib/momentRu';
import axios from 'axios';
import { initLms } from 'src/services/initLms.service';
import { initAppTheme } from 'src/composables/useAppTheme';
import { checkCodeVersionOnce } from './helpers/codeVersionCheck';

initAppTheme();

export default defineComponent({
    name: 'App',
    data () {
        return {
            timer: undefined,
            loaded: false,
        };
    },
    created () {
        this.$q.cache = {};
        this.$q.allowRefresh = true;
        initLms(this.$store).then(() => {
            this.loaded = true;
        });
    },
    computed: {
        needSpinnerShow () {
            if (window.location.pathname.startsWith('/jM5a-1Pq8')) {
                return !this.$store.getters['operatorPermissions/getFirstLoad'] && this.loaded;
            }

            return false;
        },
    },
    mounted () {
        moment.locale('ru');

        if (this.loaded) {
            this.runCodeVersionCheck();

            return;
        }

        const unwatchLoaded = this.$watch('loaded', (isLoaded) => {
            if (!isLoaded) { return; }

            unwatchLoaded();
            this.runCodeVersionCheck();
        });
    },
    methods: {
        async runCodeVersionCheck () {
            await checkCodeVersionOnce({
                axios,
                $q: this.$q,
            });
        },
    },
});
</script>

<style lang="scss">
.app-loading {
    position: absolute;
    inset: 0;
    background: var(--ac-bg);
    color: var(--ac-text);
}

.app-loading__inner.q-inner-loading {
    color: var(--ac-text);
    background: transparent;
}

.app-loading .q-inner-loading__label {
    color: var(--ac-text);
}
</style>
